<template>
  <rfq>
    <div class="tw-px-4 md:tw-px-20 tw-py-8 md:tw-py-16">
      <back-nav v-if="!($route.query.toRfq && currentTab === 'RequestQuote')" :to="backNav" />
      <v-card
          class="tw-w-full"
          flat
      >
        <div id="card-title" class="tw-px-4">
          <card-title>{{ title }}</card-title>
        </div>
        <div class="tw-flex tw-w-full tw-flex-wrap tw-justify-center">
          <transition
              name="fade"
              mode="out-in"
              appear
              :duration="500"
          >
            <component v-bind:is="currentTab" @request-submitted="viewQuote" @proceed-request="startMotorRequest"  @proceed-amani-request="startAmaniRequest" @proceed-dp-request="startDPRequest" @proceed-travel-request="startTravelRequest" @proceed-to-health-benefit-limits="proceedToBenefitsLimit" @proceed-to-health-quote="proceedToHealthQuote" @proceed-to-dp-quote="proceedToDPQuote" v-bind="results"></component>
          </transition>
        </div>
      </v-card>
    </div>
  </rfq>
</template>

<script>

import Rfq from '@/components/layout/Rfq';
import CardTitle from '@/components/shared/CardTitle';
import RequestQuote from '@/components/rfq/RequestQuote';
import QuoteSummary from '@/components/rfq/QuoteSummary';
import ChooseProduct from '@/components/rfq/ChooseProduct';
import BackNav from '@/components/buy/BackNav';
import StartHealth from '@/components/rfq/health/StartHealth';
import StartDP from '@/components/rfq/dp/StartDP';
import StartTravel from '@/components/rfq/travel/StartTravel';
import InpatientPlan from '@/components/rfq/health/InpatientPlan';
import SelectAdditionalBenefits from '@/components/rfq/health/SelectAdditionalBenefits';
import SelectBenefitLimits from '@/components/rfq/health/SelectBenefitLimits';
import HealthQuoteSummary from '@/components/rfq/health/HealthQuoteSummary';
import DPQuoteSummary from '@/components/rfq/dp/DPQuoteSummary';
import TravelQuoteSummary from '@/components/rfq/travel/TravelQuoteSummary';
import { isCustomerMotorV2Enabled } from '@/utils/motorChannel';

export default {
  name: 'Request',
  components: {
    BackNav,
    CardTitle,
    Rfq,
    RequestQuote,
    QuoteSummary,
    ChooseProduct,
    StartHealth,
    StartDP,
    StartTravel,
    DPQuoteSummary,
    TravelQuoteSummary,
    InpatientPlan,
    SelectAdditionalBenefits,
    SelectBenefitLimits,
    HealthQuoteSummary,
  },
  metaInfo: {
    title: 'Request For Quotation',
  },
  data() {
    return {
      currentTab: ChooseProduct,
      data: [],
      toRequest: false,
      showAdditionalBenefits: false,
    };
  },
  computed: {
    title() {
      if (this.currentTab === StartHealth) {
        return 'Choose who you wish to include in your cover';
      }
      if (this.currentTab === StartDP) {
        return 'Choose what you wish to include in your cover';
      }
      if (this.currentTab === StartTravel) {
        return 'Enter your travel details';
      }
      if (this.currentTab === InpatientPlan || this.currentTab === SelectBenefitLimits) {
        return 'Select the Additional Benefits of your choice';
      }
      if (this.currentTab === SelectAdditionalBenefits) {
        return 'Select your choice of additional benefit(s)';
      }
      // eslint-disable-next-line no-nested-ternary
      return this.currentTab === RequestQuote || this.currentTab === 'RequestQuote' ? 'Choose your Insurance type' : this.currentTab === ChooseProduct || this.currentTab === 'ChooseProduct' ? 'Choose which product you wish to buy ' : 'Quote Summary';
    },
    results() {
      if (this.currentTab === QuoteSummary) {
        return { quote: this.data };
      }
      if (this.currentTab === SelectBenefitLimits) {
        return { choice: this.data };
      }
      return [];
    },
    backNav() {
      if (this.currentTab === RequestQuote || this.currentTab === StartHealth) {
        return 'ChooseProduct';
      }
      if (this.currentTab === QuoteSummary) {
        return 'RequestQuote';
      }
      if (this.currentTab === InpatientPlan) {
        return StartHealth;
      }
      if (this.currentTab === SelectAdditionalBenefits) {
        return InpatientPlan;
      }
      if (this.currentTab === SelectBenefitLimits) {
        // return this.showAdditionalBenefits ? SelectAdditionalBenefits : InpatientPlan;
        return InpatientPlan;
      }
      if (this.currentTab === HealthQuoteSummary) {
        return SelectBenefitLimits;
      }
      return null;
    },
  },
  mounted() {
    // if (this.$route.query.toRfq || this.toRequest) {
    //   this.currentTab = 'RequestQuote';
    // }
    this.$root.$on('nav-back-to', (data) => {
      this.currentTab = data.currentTab;
    });
    // health events
    this.$root.$on('proceed-to-health-plan', () => {
      this.currentTab = InpatientPlan;
    });
    this.$root.$on('proceed-to-health-benefits', (yes) => {
      this.showAdditionalBenefits = yes;
      if (!yes) this.data = 'none';
      // this.currentTab = yes ? SelectAdditionalBenefits : SelectBenefitLimits;
      // NOTE: we use only both or none for now, outpatient, maternity not used
      this.data = yes ? 'both' : 'none';
      this.currentTab = SelectBenefitLimits;
    });
    // dp events
    // health events
    this.$root.$on('proceed-to-dp-plan', () => {
      this.currentTab = DPQuoteSummary;
    });
    // travel events
    this.$root.$on('proceed-to-travel-plan', () => {
      this.currentTab = TravelQuoteSummary;
    });
    this.$root.$on('start-travel-over', () => {
      this.currentTab = StartTravel;
    });
    this.applyProductFromQuery();
  },
  methods: {
    applyProductFromQuery() {
      const { product, toRfq } = this.$route.query;
      if (toRfq === 'true' || toRfq === true || product === 'motor') {
        this.startMotorRequest();
        return;
      }
      if (product === 'travel') {
        this.startTravelRequest();
        return;
      }
      if (product === 'amani') {
        this.startAmaniRequest();
        return;
      }
      if (product === 'domestic') {
        this.startDPRequest();
      }
    },
    viewQuote(data) {
      this.data = data;
      this.currentTab = QuoteSummary;
    },
    startMotorRequest() {
      if (isCustomerMotorV2Enabled()) {
        this.$router.push({ name: 'CustomerMotorStart' });
        return;
      }
      this.currentTab = RequestQuote;
    },
    startAmaniRequest() {
      this.currentTab = StartHealth;
    },
    startDPRequest() {
      this.currentTab = StartDP;
    },
    startTravelRequest() {
      this.currentTab = StartTravel;
    },
    proceedToBenefitsLimit(choice) {
      this.data = choice;
      this.currentTab = SelectBenefitLimits;
    },
    proceedToHealthQuote() {
      this.currentTab = HealthQuoteSummary;
    },
    proceedToDPQuote() {
      this.currentTab = DPQuoteSummary;
    },
    proceedToTravelQuote() {
      this.currentTab = TravelQuoteSummary;
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
& > * {
    transition-duration: 100ms;
    transition-property: opacity, transform;
    transition-timing-function: cubic-bezier(.6,.15,.35,.8);
  }

}

$delay: 60ms;
$delayStep: 60ms;

.fade-enter,
.fade-leave-to {
& > * {
    opacity: 0;
    transform: translateY(40px);
  }
}
.fade-enter-active {
& > * {
&:nth-child(2) {
   transition-delay: $delay;
 }
&:nth-child(3) {
   transition-delay: $delay + $delayStep;
 }
}
}
.fade-leave-active {
& > * {
&:nth-child(1) {
   transition-delay: $delay + $delayStep;
 }
&:nth-child(2) {
   transition-delay: $delay;
 }
}
}
</style>
